







































































import Vue, { PropType } from "vue";
import { Component } from "vue-property-decorator";
import {
  RecommendationExtra,
  throwIfInvalidStatus,
  getInternalStatusMapping
} from "../store/model";

const ApplyAndStatusCellProps = Vue.extend({
  props: {
    rowRecommendation: {
      type: Object as PropType<RecommendationExtra>,
      required: true
    }
  }
});

@Component
export default class ApplyAndStatusCell extends ApplyAndStatusCellProps {
  errorDialogOpened = false;

  // we don't want a typo in status name to go unnoticed
  checkStatus(statusName: string) {
    throwIfInvalidStatus(statusName);
    return (
      this.rowRecommendation.statusCol === getInternalStatusMapping(statusName)
    );
  }

  applyRecommendation(): void {
    this.$store.dispatch("recommendationsStore/applyGivenRecommendations", [
      this.rowRecommendation.name
    ]);
  }
}
